<template>
	<ol class="color_wrapper">
		<li class="color_item Disp_AC AkrobatM" v-for="item in colors" :key="item.value" >
			<em :style="{background: item.color}"></em>
			{{item.value}}
		</li>
	</ol>
</template>

<script>
	/**
	 * @description 带值的颜色小方块，用在GPS报告，RPE图表上的颜色说明。
	 * @prop {Array} colors [{color: 'red', value: 'danger标识' }]
	 *  */
	export default {
		name: 'clColorBlock',
		props: {
			colors: {
				type: Array,
			}
		}
	}
</script>

<style lang="scss" scoped>
	.color_wrapper {
		width: auto;
		display: flex;
		.color_item {
			color: $base-font-minor;
			margin-left: 24px;
			em {
				content: '';
				display: inline-block;
				width: 12px;
				height: 12px;
				border-radius: 2px;
				margin-right: 6px;
			}
		}
	}
</style>